import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal request table view.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Get current user parameter

        return {
            view: 'datatable', // DataTable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            columns: [
                // Define columns for the DataTable
                {
                    id: 'detailTittle', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Column height
                    tooltip: 'Detalles', // Tooltip text
                    template: function (obj) {
                        // Template for rendering cell content
                        return "<span class='webix_icon wxi-close details'></span>";
                    },
                },
                {
                    id: 'ActionTittle', // Column ID
                    header: '', // Column header
                    width: 70, // Column width
                    height: 25, // Column height
                    tooltip: 'Acción', // Tooltip text
                    hidden: !devConfig.getPermAction('withdrawalRequests', 'Edit'), // Conditional visibility based on permissions
                    css: 'prm-withdrawalRequests', // CSS class for styling
                    template: function (obj) {
                        // Template for rendering cell content
                        if (obj.State == 'A') {
                            return "<span placeholder='Aprobar' class='webix_icon wxi-close approve'></span><span class='webix_icon wxi-close torefuse'></span>";
                        } else {
                            if (obj.State == 'P') {
                                return "<span placeholder='Pagar' class='webix_icon wxi-close pay'></span>";
                            } else {
                                return '';
                            }
                        }
                    },
                },
                { id: 'Id', header: 'Id', width: 70, sort: 'int' }, // ID column
                {
                    id: 'ClientId', // Column ID
                    header: 'ID Cliente', // Column header
                    width: 80, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'Amount', // Column ID
                    header: 'Valor', // Column header
                    format: webix.i18n.priceFormat, // Formatting function for price
                    exportType: 'number', // Export type
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'State', // Column ID
                    header: 'Estado', // Column header
                    options: [
                        // Dropdown options for state
                        { id: '', value: 'None' },
                        { id: 'A', value: 'Activado' },
                        { id: 'C', value: 'Canceled' },
                        { id: 'I', value: 'Pagada' },
                        { id: 'E', value: 'Eliminado' },
                        { id: 'P', value: 'Pendiente' },
                        { id: 'R', value: 'Rechazado' },
                    ],
                },
                {
                    id: 'CreatedLocal', // Column ID
                    header: 'Fecha', // Column header
                    width: 150, // Column width
                    sort: 'int', // Sorting type
                },
            ],
            onClick: {
                // Event handlers for click events
                details: function (euv, id) {
                    // Handler for details icon click
                    var item = this.getItem(id); // Get the clicked item
                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                },
                pay: function (euv, id) {
                    // Handler for pay icon click
                    var vvthis = this; // Reference to the current context
                    webix.confirm({
                        // Confirmation dialog
                        type: 'confirm-warning',
                        text: 'Advertencia!<br/>Desea Pagar Nota de Retiro?',
                        ok: 'Pagar Nota',
                        cancel: 'Salir',
                        callback: function (action) {
                            // Callback for confirmation
                            if (action === true) {
                                var item = vvthis.getItem(id); // Get the clicked item
                                webix
                                    .ajax() // AJAX request to pay withdrawal
                                    .headers({
                                        'Content-type': 'application/json',
                                    })
                                    .post(
                                        devConfig.geturlApi() + 'Client/PayWithdrawalRequests',
                                        '{ "Id":' + item.Id + '}',
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                // Error handler
                                                webix.message('Error! ');
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                // Success handler
                                                item.State = 'I'; // Update item state
                                                webix.message('Nota de Retiro Pagada'); // Success message
                                                vthis.$$('table').clearAll(); // Clear the table
                                                vthis.$$('table').load(url); // Reload the table data
                                            },
                                        },
                                    );
                            }
                        },
                    });
                },
                approve: function (euv, id) {
                    // Handler for approve icon click
                    var vvthis = this; // Reference to the current context
                    webix.confirm({
                        // Confirmation dialog
                        type: 'confirm-warning',
                        text: 'Advertencia!<br/>Desea Aprobar Nota de Retiro?',
                        ok: 'Aprobar Nota',
                        cancel: 'Salir',
                        callback: function (action) {
                            // Callback for confirmation
                            if (action === true) {
                                var item = vvthis.getItem(id); // Get the clicked item
                                webix
                                    .ajax() // AJAX request to approve withdrawal
                                    .headers({
                                        'Content-type': 'application/json',
                                    })
                                    .post(
                                        devConfig.geturlApi() + 'Client/AllowWithdrawalRequests',
                                        '{ "Id":' + item.Id + '}',
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                // Error handler
                                                webix.message('Error! ');
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                // Success handler
                                                item.State = 'P'; // Update item state
                                                webix.message('Nota de Retiro Aprobado'); // Success message
                                                vthis.$$('table').clearAll(); // Clear the table
                                                vthis.$$('table').load(url); // Reload the table data
                                            },
                                        },
                                    );
                            }
                        },
                    });
                },
                torefuse: function (euv, id) {
                    // Handler for refuse icon click
                    var vvthis = this; // Reference to the current context
                    webix.confirm({
                        // Confirmation dialog
                        type: 'confirm-warning',
                        text: 'Advertencia!<br/>Desea Rechazar Nota de Retiro?',
                        ok: 'Rechazar Nota',
                        cancel: 'Salir',
                        callback: function (action) {
                            // Callback for confirmation
                            if (action === true) {
                                var item = vvthis.getItem(id); // Get the clicked item
                                webix
                                    .ajax() // AJAX request to refuse withdrawal
                                    .headers({
                                        'Content-type': 'application/json',
                                    })
                                    .post(
                                        devConfig.geturlApi() + 'Client/CancelClientRequests',
                                        '{ "Id":' + item.Id + '}',
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                // Error handler
                                                webix.message('Error! ');
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                // Success handler
                                                item.State = 'E'; // Update item state
                                                webix.message('Nota de Retiro Rechazada'); // Success message
                                                vthis.$$('table').clearAll(); // Clear the table
                                                vthis.$$('table').load(url); // Reload the table data
                                            },
                                        },
                                    );
                            }
                        },
                    });
                },
            },
            editable: true, // Enable editing
            tooltip: true, // Enable tooltips
            math: true, // Enable math operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID
            // Data source URL for the table
            url: devConfig.geturlApi() + 'es/Client/GetClientWithdrawalRequests?PlayerId=' + cur_user + '&',
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url = grid.data.url; // Store the grid URL

        this.on(this.app, 'bonusReport:filter', (filterData) => {
            // Event listener for filter changes
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string

            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'MaxCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Append current user ID to query string
            grid.clearAll(); // Clear the grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
        });

        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event listener for item clicks
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        grid.attachEvent('onBeforeEditStart', function (id) {
            // Event listener before editing starts
            var item = this.getItem(id); // Get the item being edited
            console.log(item);
            if (id.column == 'Action') {
                // Check if the edited column is Action
                var options = this.getColumnConfig('Action').collection; // Get action options
                if (item.State == 'A') {
                    options.remove('P'); // Remove 'Pay' option if state is 'A'
                } else if (item.State == 'P') {
                    options.remove('A'); // Remove 'Approve' option if state is 'P'
                } else {
                    return false; // Prevent editing for other states
                }
                console.log(id);
            }
        });

        grid.attachEvent('onAfterEditStop', function (state, editor, ignoreUpdate) {
            // Event listener after editing stops
            console.log(state);
            var item = this.getItem(editor.row); // Get the edited item
            console.log(item);
            if (state.value != state.old) {
                // Check if the value has changed
                if (state.value == 'A') {
                    // If approved
                    webix
                        .ajax() // AJAX request to approve withdrawal
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/AllowWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                // Error handler
                                webix.message('Error! ');
                            },
                            success: function (text, data, XmlHttpRequest) {
                                // Success handler
                                item.State = 'P'; // Update item state
                                webix.message('Cell value was changed'); // Success message
                            },
                        });
                }
                if (state.value == 'P') {
                    // If paid
                    webix
                        .ajax() // AJAX request to pay withdrawal
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/PayWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                // Error handler
                                webix.message('Error! ');
                            },
                            success: function (text, data, XmlHttpRequest) {
                                // Success handler
                                item.State = 'I'; // Update item state
                                webix.message('Cell value was changed'); // Success message
                            },
                        });
                }
                if (state.value == 'E') {
                    // If canceled
                    webix
                        .ajax() // AJAX request to cancel withdrawal
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/CancelClientRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                // Error handler
                                webix.message('Error! ');
                            },
                            success: function (text, data, XmlHttpRequest) {
                                // Success handler
                                item.State = 'E'; // Update item state
                                webix.message('Cell value was changed'); // Success message
                            },
                        });
                }
            }
        });

        this.on(this.app, 'player:select', (id) => {
            // Event listener for player selection
            grid.load(
                // Load data for the selected player
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id,
            );
        });
    }
}

// FILE DOCUMENTED
